module.exports = __webpack_public_path__ + "assets/images/project/header/image-background-header2.jpg?v=066c480f";